import { Nav, Navbar } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import './Navigation.css'
import logo from '../../container/image/logo.png'
import getNavItems from "./util/NavItems";
import { useContext, useRef } from "react";
import DashboardContext from "../../context/dashboardContext";

const Navigation = () => {
    const dashContext = useContext(DashboardContext);
    const counts = [
        dashContext.areaCount,
        dashContext.orders2Count,
        dashContext.productCategoryCount,
        dashContext.productCount,
        '',
        dashContext.jobCategoryCount,
        dashContext.personsCount,
        '',
        dashContext.placeCategoryCount,
        dashContext.placeCount,
        '',
        dashContext.ordersCount,
        '',
        dashContext.usersCount,
        dashContext.commentsCount,
        dashContext.viewersCount
    ]
    const navItems = getNavItems();
    const toggleRef = useRef(null);
    
    return (
        <Navbar collapseOnSelect expand="" bg="dark" variant="dark" className="">
            <NavLink
                to = "/dashboard" exact
                className="navbar-brand py-0  "
                style={{ height: "100%" }}
            >
                <img src={logo} className="navbar_brand" alt=""/>
            </NavLink>
            <span className="mx-auto text-light d-none d-lg-block">پنل مدیریت</span>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className="d-lg-none" ref={toggleRef}/>
            <Nav>
                <NavLink
                    to="/dashboard/logout"
                    className="nav-link"
                >
                    خروج
                </NavLink>
            </Nav>
            <Navbar.Collapse id="responsive-navbar-nav" className="d-lg-none">
                <Nav className="mr-auto">
                {
                    navItems.map((item, index) => 
                        <NavLink
                            key={item.id}
                            to={item.link}
                            className="nav-link"
                            onClick={() => toggleRef.current.click()}
                            >
                            <i className={item.iconClassName}></i>
                            {item.name}
                            <span className="badge badge-success badge-pill mt-1 float-left">{counts[index]}</span>
                        </NavLink>
                    )
                }
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
};

export default Navigation;
